import { Flex, Text, SimpleGrid, Button, useMantineTheme } from "@mantine/core";
import {
  PasswordInputControlled,
  TextInputControlled,
} from "../../../components";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import RecoverPassword from "../RecoverPassword";
import { useAuth } from "../../../context/auth";
import { validationSignIn } from "../../../utils/validation";
import { ISignIn } from "../../../utils/validation/schemas/validationSignIn";
import { useRef, useState } from "react";
import { loginUser, useUserIP } from "../../../hooks/useAuthService";
import { useNavigate } from "react-router-dom";
import LayoutFormAuth from "../_components/LayoutFormAuth";
import { useTranslation } from "react-i18next";
import { whitelabel_id } from "../../../api";

interface IProps {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
}

const SignIn = ({ setIsLoading, isLoading }: IProps) => {
  const abortControllerRef = useRef<AbortController | null>(null);
  const { signIn } = useAuth();
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    data: dataIp,
    //  isError: isErrorIp
  } = useUserIP();
  const userIp = !!dataIp?.data.ip ? dataIp?.data.ip : "";
  const [error, setError] = useState<string | null>(null);
  const [openRecoverPassword, setOpenRecoverPassword] =
    useState<boolean>(false);

  const methods = useForm<ISignIn>({
    resetOptions: {
      keepValues: true,
    },
    mode: "onSubmit",
    resolver: yupResolver(validationSignIn),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const { handleSubmit } = methods;

  const onSubmit: SubmitHandler<ISignIn> = async (data) => {
    setError(null);
    setIsLoading(true);
    abortControllerRef.current = new AbortController();
    // if (!!!userIp && !!isErrorIp) {
    //   setError("Falha ao obter o endereço IP. Entre em contato com Suporte.");
    //   setIsLoading(false);
    //   return;
    // }
    const dataSend = {
      ...data,
      whitelabel_id: whitelabel_id,
      client_ip: userIp,
    };

    try {
      const response = await loginUser(dataSend, {
        signal: abortControllerRef.current?.signal,
      });
      if (!!response.data) {
        await signIn(response.data);
      }
    } catch (error: any) {
      const erro = error?.response?.data;

      if (!!!erro) {
        setError(t("autenticacao.acessar_conta.erro"));
        return;
      }
      if (erro?.statusCode === 403) {
        navigate("/autenticacao/verficar-email");
        setError(erro.statusText || t("autenticacao.acessar_conta.erro_403"));
      } else if (erro.statusCode === 404 || erro.statusCode === 401) {
        setError(t("autenticacao.acessar_conta.erro_404"));
      } else {
        setError(t("autenticacao.acessar_conta.erro"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LayoutFormAuth<ISignIn> methods={methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{
          display: "flex",
          gap: "24px",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Text
          fw={{ base: 600 }}
          fz={{ base: 24 }}
          lh={{ base: "37.2px" }}
          color={theme.colors.basic[5]}
        >
          {t("autenticacao.acessar_conta.title")}
        </Text>
        <SimpleGrid
          cols={2}
          breakpoints={[{ maxWidth: "97rem", cols: 1, spacing: "md" }]}
          spacing="32px"
          verticalSpacing="24px"
        >
          <TextInputControlled
            name="email"
            label={t("global.input.email.label")}
            placeholder={t("global.input.email.placeholder")}
            withAsterisk
          />
          <PasswordInputControlled
            name="password"
            label={t("global.input.password.label")}
            placeholder={t("global.input.password.placeholder")}
            withAsterisk
            hasTooltip={true}
          />
        </SimpleGrid>
        <Flex justify="end">
          {/* <Checkbox
                  onClick={handleAcceptSave}
                  color="primary.1"
                  size="md"
                  icon={HiCheck}
                  label="Permanecer logado"
                /> */}
          <Button
            h="auto"
            onClick={() => setOpenRecoverPassword(true)}
            variant="link"
          >
            {t("autenticacao.acessar_conta.forget_password.title")}
          </Button>
          {openRecoverPassword ? (
            <RecoverPassword
              openRecoverPassword={openRecoverPassword}
              setOpenRecoverPassword={setOpenRecoverPassword}
            />
          ) : null}
        </Flex>
        <Button type="submit" variant="primary" fullWidth loading={isLoading}>
          {t("autenticacao.acessar_conta.title")}
        </Button>
        {error && <Text color="red">{error}</Text>}
      </form>
    </LayoutFormAuth>
  );
};

export default SignIn;
